document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-planner-form]').forEach((form) => {
        form.addEventListener('submit', (event) => {
            const licensePlate = form.querySelector('[name="licensePlate"]');

            if (licensePlate && licensePlate.value.trim() !== '') {
                return;
            }

            event.preventDefault();
            window.open(form.dataset.plannerForm, '_blank', 'noopener');
        });
    });
});
